import { render, staticRenderFns } from "./RecordsTable.vue?vue&type=template&id=1c2293d6&scoped=true"
import script from "./RecordsTable.vue?vue&type=script&lang=js"
export * from "./RecordsTable.vue?vue&type=script&lang=js"
import style0 from "./RecordsTable.vue?vue&type=style&index=0&id=1c2293d6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2293d6",
  null
  
)

export default component.exports